import React from 'react';
import { cn } from '../../../utils';

const Row = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('row gap-1', className)} {...props}>
      {children}
    </div>
  );
};

export default Row;
